import { cn } from "@discovery/classnames";
import { SonicImageDplus } from "../../atoms/sonic-image";
import * as M from "@discovery/prelude/lib/data/maybe";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { CarouselContentCard } from "../../../components/molecules/carouselCard";
import { Icon, Icons } from "../../atoms/icon";
import { Link } from "../../atoms/link";
import { PlaceholderImage } from "../../atoms/placeholder-image";
import * as Styles from "./styles.css";
import { pushModuleLinkTracking } from "@discovery/common-dplus/lib/adobe";
export const CarouselItem = ({ name, route, packages, premiumPackages, index, ctaLabelM = M.empty(), customAttr = M.empty(), mWebBannerImg, descriptionM = M.empty(), premium, image, isPremiumCarousel, type, componentIdM, }) => {
    const mobileImg = isPremiumCarousel ? image : mWebBannerImg;
    const isPremium = premiumPackages.includes(packages);
    const componentId = componentIdM && M.fromMaybe(componentIdM, "");
    const appendAdobeUrlToRoute = componentId === "masthead" ? `?ic1=${type}:homeBanner:topbanner` : ""; //Appending adobe url to the current routr only for masthead items in home
    const sendAnalyticsEvents = () => {
        type &&
            pushModuleLinkTracking(config.standardPageRouteFragments.home, index.toString(), name, type, "www.discoveryplus.in/home", route);
    };
    return (React.createElement(Link, { classNameM: M.of(Styles.container), href: route + appendAdobeUrlToRoute, onClick: sendAnalyticsEvents },
        React.createElement("div", { className: premium ? Styles.preimiumMask : Styles.mask },
            React.createElement("div", { className: Styles.maskLeft })),
        React.createElement("div", { className: premium ? Styles.premiumImageWrapper : Styles.mobileImageWrapper },
            isPremium && premium && (React.createElement(Icon, { type: Icons.PremiumMemberIcon, className: cn(Styles.premiumIconLabel, Styles.premiumcarousel), color: "red" })),
            React.createElement(PlaceholderImage, null),
            mobileImg && (React.createElement(SonicImageDplus, { src: mobileImg.src, quality: 75, className: premium ? Styles.premiumImage : Styles.image, width: 550 }))),
        React.createElement("div", { className: Styles.contentWrapper },
            React.createElement(CarouselContentCard, { name: name, ctaLabelM: ctaLabelM, descriptionM: descriptionM, customAttr: customAttr }))));
};

